import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { getShipmentStatusColor } from '../../ExtraFunctionality/ShipmentStatusColor';
import {
  Box,
  Typography,
  Tab,
  Tabs,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Chip,
  Drawer,
  AvatarGroup,
  Avatar,
  Grid,
  TextField,
  Divider,
  Card,
  Tooltip
} from '@mui/material';
import { Description as DescriptionIcon } from '@mui/icons-material';
import './ViewShipment.css';
import {
  GetCarriers,
  GetClaimedShipmentDetails,
  GetProofOfDelivery,
  GetQuoteDetail,
  GetShipmentDetails,
  TrackShipmentRequest,
  UpdateShipmentContacts,
  UpdateShipmentDetail
} from '../../apis/Agency';
import { useSelector } from 'react-redux';
import { CardContent } from '@mui/material';
import { Folder } from '@mui/icons-material';
import { ErrorToast } from '../../components/Toasts';
import { Col, Row } from 'reactstrap';
import TrackShipmentDetails from '../TrackShipment/TrackShipmentDetails';
import TrackHistory from '../TrackShipment/TrackHistory';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { base_logo_url } from '../../apis/constants';
import CloseIcon from '@mui/icons-material/Close';
import html2pdf from 'html2pdf.js';
import './bol_table.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useReactToPrint } from 'react-to-print';
import { formatDateUTC, formatPhoneNumber } from '../../apis/Utils';
import { useMediaQuery, useTheme } from '@mui/material';
import PackagingSlip from './PackagingSlip';
import BillOfLading from './BillOfLading';
import ShipmentDocuments from './ShipmentDocuments';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CircularTMSLoader from '../../TmsLoader/TmsLoader';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PaymentsIcon from '@mui/icons-material/Payments';
import TimelineIcon from '@mui/icons-material/Timeline';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessIcon from '@mui/icons-material/Business';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

// VERTICAL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 1, width: '115%' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

// HORIZONTAL

function TabPanelX(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3, py: 1, maxWidth: '100%' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanelX.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function ViewShipment(props) {
  const claimDetailsAllowed = props?.claimDetailsAllowed;

  const formatFileSize = bytes => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const contentRef = useRef(null);

  const [openPrintPDfDialogData, setOpenPrintPDfDialogData] = useState('');
  const [numberOfPrintsColmnVise, setNumberOfPrintsColmnVise] = useState(1);
  const [selectedPrintOption, setSelectedPrintOption] = useState(1);
  const [numberOfPrints, setNumberOfPrints] = useState(1);

  const [viewShipmentsDetails, setViewShipmentsDetails] = useState([]);

  const handleFetchShipmentsDetails = row => {
    GetShipmentDetails(rowData.shipmentId)
      .then(res => res.status === 200 && setViewShipmentsDetails(res.data.data))
      .catch(err => ErrorToast(err?.message));
  };

  useEffect(() => {
    handleFetchShipmentsDetails(props.rowData.shipmentId);
  }, []);

  const handleAfterPrint = React.useCallback(() => {}, []);

  const handleBeforePrint = React.useCallback(() => {
    return Promise.resolve();
  }, []);

  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
    documentTitle: `${openPrintPDfDialogData.carrierName} labels`,
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint
  });

  const originDetails = viewShipmentsDetails?.find(
    item => item.itemType === 'Pickup'
  );
  const destinationDetails = viewShipmentsDetails?.find(
    item => item.itemType === 'Delivery'
  );

  const handleDateTimeShow = (timeStamp, type) => {
    const dateTimeString = timeStamp + 'Z';
    const dateTime = new Date(dateTimeString);
    const date = new Date(dateTimeString);
    const bolDate = new Date(timeStamp);
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const timeOptions = new Intl.DateTimeFormat('default', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: userTimeZone
    }).format(dateTime);

    const dateOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };

    const formattedDate = date.toLocaleDateString(undefined, dateOptions);
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    const formattedBolDate = bolDate.toLocaleDateString('en-US', options);
    if (type === 'time') {
      return timeOptions;
    }
    if (type === 'date') {
      return formattedDate;
    }
    if (type === 'bol') {
      return formattedBolDate;
    }
  };

  const shipmentStatus = props?.rowData?.shipmentStatus;
  const [trackShipmentData, setTrackShipmentData] = useState(null);

  const getStatusIcon = status => {
    switch (status) {
      case 'Paid':
        return (
          <CheckCircleIcon sx={{ mx: -1 }} fontSize='11' color='success' />
        );
      case 'Rejected':
        return <CancelIcon sx={{ mx: -1 }} fontSize='11' color='error' />;
      case 'Submitted':
        return (
          <HourglassEmptyIcon sx={{ mx: -1 }} fontSize='11' color='info' />
        );
      default:
        return null;
    }
  };

  const handleSuccessTrackShip = apiRes => {
    setLoader(false);
    setTrackShipmentData(apiRes);
  };

  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [carriersList, setCarriersList] = useState([]);

  useEffect(() => {
    GetCarriers(AgencyID)
      .then(res => res.status === 200 && setCarriersList(res.data.data || []))
      .catch(() => setCarriersList([]));
  }, [AgencyID]);

  const [, setBlobUrlPOD] = useState('');
  const [loader, setLoader] = useState(false);
  const [docLoader, setDocLoader] = useState(false);
  const [historyError, setHistoryError] = useState(false);
  const [PodDocLoader, setPodDocLoader] = useState(false);
  const [claimDetails, setClaimDetails] = useState({});
  const [viewType, setViewType] = useState('Track');

  const handleTrackShipmentRequest = (selectedRowData, event, type) => {
    if (type === 'history') {
      setViewType(type);
      event.stopPropagation();
    } else {
      setLoader(true);
      event.stopPropagation();
      const obj = {
        carrierInfo: {
          id: selectedRowData?.carrierId ? selectedRowData.carrierId : 0,
          name: selectedRowData?.carrierName ? selectedRowData.carrierName : '',
          logo: ''
        },
        proNumber: selectedRowData?.proNumber,
        shipmentId: selectedRowData?.shipmentId,
        locationId: selectedRowData?.locationId,
        shipmentType: selectedRowData?.shipmentType,
        agencyId: AgencyID ? AgencyID : 0
      };

      TrackShipmentRequest(obj)
        .then(res => {
          if (res.status === 200) {
            handleSuccessTrackShip(res.data);
          } else if (res.status === 204) {
            setLoader(false);
            ErrorToast('No tracking information available for this shipment.');
          }
        })
        .catch(err => {
          setLoader(false);
          ErrorToast(JSON.stringify(err?.response?.data));
        });
    }
  };

  const viewPOD = (fileType, base64Data, urls, fileName) => {
    let mimeType;
    if (base64Data !== null) {
      switch (fileType.toLowerCase()) {
        case 'pdf':
        case '.pdf':
          mimeType = 'application/pdf';
          break;
        case 'tif':
        case 'tiff':
        case 'tifv':
          mimeType = 'image/tiff';
          break;
        case '.gif':
        case 'gif':
          mimeType = 'image/gif';
          break;
        case 'jpg':
        case '.jpg':
          mimeType = 'image/jpg';
          break;
        default:
          ErrorToast('Unsupported file type');
          return;
      }

      const linkSource = `data:${mimeType};base64,${base64Data}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;

      downloadLink.download = fileName.endsWith(`.${fileType}`)
        ? fileName
        : `${fileName}.${fileType}`;

      downloadLink.click();
    }
    if (urls && Array.isArray(urls)) {
      urls.forEach(url => {
        if (url) {
          window.open(url, '_blank');
        }
      });
    }
  };

  const getCliamDetails = () => {
    GetClaimedShipmentDetails(rowData?.shipmentId)
      .then(res => res.status === 200 && setClaimDetails(res.data.data))
      .catch(err => ErrorToast(err?.message));
  };

  const handleProofOfDeliveryRequest = status => {
    setPodDocLoader(true);
    const obj = {
      carrier: {
        id: rowData?.carrierId ? rowData.carrierId : 0,
        name: rowData?.carrierName ? rowData.carrierName : 'string',
        logo: 'string'
      },
      proNumber: rowData?.proNumber.trim(),
      shipmentId: rowData?.shipmentId,
      locationId: rowData?.locationId,
      agencyId: AgencyID ? AgencyID : 0
    };
    GetProofOfDelivery(obj)
      .then(res => {
        res.status === 200 && setPodDocLoader(false);
        viewPOD(
          res.data.fileExtension,
          res.data.fileBase64,
          res.data.urLs,
          `Proof of Delivery (${obj.carrier.name}  ${obj.proNumber})`
        );
      })
      .catch(err => {
        setPodDocLoader(false);
        setBlobUrlPOD(null);
        ErrorToast(JSON.stringify(err?.response?.data));
      });
  };

  const rowData = props?.rowData;

  const [valueY, setValueY] = useState(0);
  const [shipperApiMsgs, setShipperApiMsgs] = useState('');
  const [carrierApiMsgs, setCarrierApiMsgs] = useState('');
  const [openPrintPDfDialog, setOpenPrintPDfDialog] = useState(false);
  const [openLabelsDialog, setOpenLabelsDialog] = useState(false);

  const [TLCoressPDrawer, setTLCoressPDrawer] = useState(false);
  const handleCloaseTLCoressPDrawer = () => {
    setValueY(0);
    setTLCoressPDrawer(false);
  };

  const handleSuccessResponse = apiRes => {
    setHistoryError(false);
    const carrierData = apiRes.data.data.details.filter(
      items => items.actionByFlag.toLowerCase() === 'carrier'
    );

    setShipperApiMsgs(apiRes.data.data.details);
    setCarrierApiMsgs(carrierData);
    setDocLoader(false);
  };

  const handleGetCorrHistory = apiRes => {
    if (rowData?.sessionId) {
      GetQuoteDetail(rowData?.sessionId)
        .then(res => res.status === 200 && handleSuccessResponse(res))
        .catch(err => {
          setDocLoader(false);
          ErrorToast(err?.message);
        });
    } else {
      setHistoryError(true);
      setDocLoader(false);
    }
  };

  const handleGetQuote = () => {
    handleGetCorrHistory();
  };

  const handleChangeY = (event, newValue) => {
    setValueY(newValue);
    if (newValue === 3) {
      setDocLoader(true);
      handleGetQuote();
    }
  };

  useEffect(() => {
    if (
      rowData?.shipmentType !== 'TL' &&
      (shipmentStatus === 'InTransit' ||
        shipmentStatus === 'Delivered' ||
        (rowData?.proNumber && shipmentStatus === 'Booked'))
    ) {
      handleTrackShipmentRequest(
        rowData,
        { stopPropagation: () => {} },
        'track'
      );
    }
    if (
      rowData?.shipmentType === 'TL' &&
      (shipmentStatus === 'InTransit' || shipmentStatus === 'Delivered')
    ) {
      setDocLoader(true);
      handleGetQuote();
    }
    if (
      claimDetailsAllowed &&
      rowData?.shipmentType !== 'TL' &&
      rowData?.claimStatus !== '' &&
      (shipmentStatus === 'Delivered' || shipmentStatus === 'InTransit')
    ) {
      getCliamDetails();
    }
  }, []);

  const [valueX] = useState(0);
  const [, setIsFullScreen] = useState(false);

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullScreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
    };
  }, []);

  const handleFullScreenChange = () => {
    setIsFullScreen(document.fullscreenElement !== null);
  };

  const removeTableCss = finalRes => {
    const regexPattern = /<style[^>]*>([\s\S]*?)<\/style>/gi;

    const updatedHtml = finalRes.replace(regexPattern, (match, styles) => {
      const stylesWithoutTable = styles.replace(
        /(?:table|td|th)\s*\{[^}]*\}/gi,
        ''
      );
      return `<style>${stylesWithoutTable} table { font-size: 12px; } td { padding: 10px; }</style>`;
    });
    return updatedHtml;
  };

  const handleCorresHistory = apiRes => {
    const fontSizeToUpdate = removeTableCss(apiRes);
    return fontSizeToUpdate;
  };

  const handlePDFPrintClose = () => {
    setOpenPrintPDfDialog(false);
  };

  const hanldeCloseLabels = () => {
    setOpenLabelsDialog(false);
    setOpenPrintPDfDialogData('');
    setNumberOfPrints(1);
    setNumberOfPrintsColmnVise(1);
    setSelectedPrintOption(1);
  };

  const handleUpdateBOLDialog = selectedShipment => {
    setFormData({
      shipmentId: Number(selectedShipment?.shipmentId) ?? 0,
      originOpenTime: selectedShipment?.pickupStartTime ?? '',
      originCloseTime: selectedShipment?.pickupEndTime ?? '',
      destinationOpenTime: selectedShipment?.deliverStartTime ?? '',
      destinationCloseTime: selectedShipment?.deliverEndTime ?? '',
      origin: {
        personName: selectedShipment?.originContactPerson ?? '',
        phoneNumber: selectedShipment?.originContactPhone ?? '',
        faxNumber: '',
        companyName: selectedShipment?.originCompany ?? '',
        phoneExtension: '',
        email: selectedShipment?.originContactEmail ?? ''
      },
      destination: {
        personName: selectedShipment?.destinationContactPerson ?? '',
        phoneNumber: selectedShipment?.destinationContactPhone ?? '',
        faxNumber: '',
        companyName: selectedShipment?.destinationCompany ?? '',
        phoneExtension: '',
        email: selectedShipment?.destinationContactEmail ?? ''
      }
    });
    props?.handleCloseBolDialog(true);
  };

  const generatePDF = async (cName, pgWidth, pgHeight, fileName) => {
    const element = document.getElementById('pdf-content');

    if (fileName !== 'bol') {
      const widthInPoints = 4 * 72;
      const heightInPoints =
        numberOfPrintsColmnVise === 1
          ? 6.1 * 72
          : numberOfPrintsColmnVise === 2
            ? 6.05 * 72
            : 6.01 * 72;

      const pageSize = {
        width: widthInPoints,
        height: heightInPoints
      };

      const pdfOptions = {
        filename: `${cName}_${fileName}.pdf`,
        html2canvas: {
          scale: 3,
          logging: true
        },
        jsPDF: {
          unit: 'pt',
          format: [pageSize.width, pageSize.height],
          orientation: 'portrait'
        }
      };

      await html2pdf(element, pdfOptions);
    } else {
      const contentHeight = element.scrollHeight;
      const heightInPoints =
        rowData?.shipmentType === 'TL'
          ? contentHeight - (contentHeight * 1) / 60
          : contentHeight - (contentHeight * 25) / 100;

      const pageSize = {
        width: pgWidth,
        height: heightInPoints
      };

      const pdfOptions = {
        filename: `${cName}_${fileName}.pdf`,
        html2canvas: {
          scale: 3,
          logging: false
        },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        jsPDF: {
          unit: 'pt',
          format: [pageSize.width, pageSize.height],
          orientation: 'portrait'
        }
      };

      await html2pdf(element, pdfOptions);
    }
  };

  const printData = rowData => {
    GetShipmentDetails(rowData.shipmentId)
      .then(res => {
        if (res.status === 200) {
          if (rowData.shipmentType === 'Parcel') {
            window.open(rowData.dispatchInput1, '_blank');
          } else {
            rowData.details = res.data.data;
            setOpenLabelsDialog(true);
            setOpenPrintPDfDialogData(rowData);
          }
        }
      })
      .catch(err => ErrorToast(err?.message));
  };

  const handleChangeNoOfPrints = e => {
    setNumberOfPrintsColmnVise(0);
    setNumberOfPrints(0);

    const value = parseInt(e.target.value, 10);
    setSelectedPrintOption(value);

    switch (value) {
      case 1:
        setNumberOfPrintsColmnVise(1);
        setNumberOfPrints(1);
        break;
      case 2:
        setNumberOfPrintsColmnVise(2);
        setNumberOfPrints(1);
        break;
      case 4:
        setNumberOfPrintsColmnVise(4);
        setNumberOfPrints(1);
        break;
      case 6:
        setNumberOfPrintsColmnVise(6);
        setNumberOfPrints(1);
        break;
      default:
        break;
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [formData, setFormData] = useState({});
  const [, setOpen] = useState(false);
  const [bolLoader, setBolLoader] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setBolLoader(props?.loading);
  }, [props?.loading]);

  const handleChange = (section, field, value) => {
    setFormData(prev => {
      if (section === 'origin' || section === 'destination') {
        return {
          ...prev,
          [section]: {
            ...prev[section],
            [field]: value
          }
        };
      } else {
        return {
          ...prev,
          [field]: value
        };
      }
    });

    setErrors(prev => {
      const next = { ...prev, [section]: { ...(prev[section] || {}) } };

      if (field === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const msg = emailRegex.test(value) ? '' : 'Please enter a valid email';
        if (msg) {
          next[section].email = msg;
        } else {
          delete next[section].email;
        }
      }

      if (
        (section === 'origin' || section === 'destination') &&
        ['companyName', 'personName', 'phoneNumber'].includes(field)
      ) {
        if (!value?.trim()) {
          next[section][field] = `${
            field === 'companyName'
              ? 'Company Name'
              : field === 'personName'
                ? 'Contact Name'
                : 'Phone'
          } is required`;
        } else {
          delete next[section][field];
        }

        if (field === 'phoneNumber') {
          const digitsOnly = value.replace(/\D/g, '');
          if (digitsOnly.length !== 10) {
            next[section][field] = 'Phone number must be 10 digits';
          }
        }
      }

      if (Object.keys(next[section]).length === 0) {
        delete next[section];
      }

      return next;
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    setBolLoader(true);

    if (Object.keys(errors).length === 0) {
      try {
        const res = await UpdateShipmentContacts(formData);

        if (res.status === 200) {
          const detailsArray = Array.isArray(viewShipmentsDetails)
            ? viewShipmentsDetails
            : [viewShipmentsDetails];

          for (const detail of detailsArray) {
            const detailsRes = await UpdateShipmentDetail(detail);

            if (detailsRes.status !== 200) {
              ErrorToast('Something went wrong while updating shipment');
              setBolLoader(false);
              return;
            }
          }

          await handleFetchShipmentsDetails(props.rowData.shipmentId);
          setBolLoader(false);

          if (props?.onUpdated) {
            props.onUpdated();
            handleClose();
          }
        } else {
          setBolLoader(false);
          ErrorToast('Error while updating shipment contacts');
        }
      } catch (err) {
        console.error(err);
        setBolLoader(false);
        ErrorToast(err?.message || 'Error while updating shipment');
      }
    } else {
      setBolLoader(false);
      ErrorToast('Please fix form errors before saving');
    }
  };

  const damagedOrShortageClaim =
    claimDetails?.claimType === 'Damage' ||
    claimDetails?.claimType === 'Shortage';
  const concealedDamagedClaim = claimDetails?.claimType === 'Concealed Damage';

  const InfoRow = ({ label, value, valueColor }) =>
    value ? (
      <Box sx={{ mb: 1 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#64748b' }}>
          {label}
        </Typography>
        <Typography
          sx={{ fontSize: 13, fontWeight: 600, color: valueColor || '#1e293b' }}
        >
          {value}
        </Typography>
      </Box>
    ) : null;

  const commodityRows = (viewShipmentsDetails || []).filter(
    r => r.itemType !== 'Pickup' && r.itemType !== 'Delivery'
  );
  const totalW = commodityRows.reduce(
    (s, c) => s + (Number(c.netWeight) || 0),
    0
  );
  const totalUnits = commodityRows.reduce(
    (s, c) => s + (Number(c.units) || 0),
    0
  );
  const totalPcs = commodityRows.reduce(
    (s, c) => s + (Number(c.pieces) || 0),
    0
  );

  const isInTransitOrDelivered =
    shipmentStatus === 'InTransit' || shipmentStatus === 'Delivered';
  const pickupDateValue = isInTransitOrDelivered
    ? rowData.actualPickupDate
    : rowData.pickupDate;
  const deliveryDateValue =
    shipmentStatus === 'Delivered'
      ? rowData.actualDeliveryDate
      : rowData.deliveryDate;
  const referenceNumber =
    rowData?.proNumber ||
    rowData?.bolNumber ||
    rowData?.quoteNumber ||
    rowData?.soNumber ||
    '—';

  // rowData.leastCostCarrier is a carrier ID, not a display name/logo —
  // resolve it against the agency's carrier list.
  const leastCostCarrierInfo = carriersList.find(
    c => String(c.carrierId) === String(rowData?.leastCostCarrier)
  );

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      {/* UPDATE BOL DIALOG */}
      <Dialog
        open={props?.updateBOLDialg}
        onClose={() => {
          setFormData({});
          props?.handleCloseBolDialog(false);
        }}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>Update BOL</DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography fontWeight={500}>Shipper Details</Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                size='small'
                fullWidth
                label='Company Name'
                value={formData.origin?.companyName}
                onChange={e =>
                  handleChange('origin', 'companyName', e.target.value)
                }
                error={Boolean(errors.origin?.companyName)}
                helperText={errors.origin?.companyName}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                size='small'
                fullWidth
                label='Contact Name'
                value={formData.origin?.personName}
                onChange={e =>
                  handleChange('origin', 'personName', e.target.value)
                }
                error={Boolean(errors.origin?.personName)}
                helperText={errors.origin?.personName}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                size='small'
                fullWidth
                label='Phone'
                inputProps={{ maxLength: 14 }}
                value={formatPhoneNumber(formData.origin?.phoneNumber)}
                onChange={e =>
                  handleChange(
                    'origin',
                    'phoneNumber',
                    formatPhoneNumber(e.target.value)
                  )
                }
                error={Boolean(errors.origin?.phoneNumber)}
                helperText={errors.origin?.phoneNumber}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                size='small'
                fullWidth
                label='Email'
                value={formData.origin?.email}
                onChange={e => handleChange('origin', 'email', e.target.value)}
                error={Boolean(errors.origin?.email)}
                helperText={errors.origin?.email}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end'
                }}
              >
                <Grid>
                  <Typography fontWeight={500}>Pickup Hours</Typography>
                </Grid>
                <Grid
                  container
                  gap={1}
                  sx={{
                    mt: 1,
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <Grid sm={5.8}>
                    <TextField
                      size='small'
                      label='Open Time'
                      InputLabelProps={{ shrink: true }}
                      value={formData?.originOpenTime || ''}
                      onChange={e => {
                        handleChange('', 'originOpenTime', e.target.value);
                      }}
                      type='time'
                      fullWidth
                    />
                  </Grid>
                  <Grid sm={5.8}>
                    <TextField
                      size='small'
                      label='Close Time'
                      value={formData?.originCloseTime || ''}
                      InputLabelProps={{ shrink: true }}
                      onChange={e => {
                        handleChange('', 'originCloseTime', e.target.value);
                      }}
                      type='time'
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} mt={2}>
              <Typography fontWeight={500}>Consignee Details</Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                size='small'
                fullWidth
                label='Company Name'
                value={formData.destination?.companyName}
                onChange={e =>
                  handleChange('destination', 'companyName', e.target.value)
                }
                error={Boolean(errors.destination?.companyName)}
                helperText={errors.destination?.companyName}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                size='small'
                fullWidth
                label='Contact Name'
                value={formData.destination?.personName}
                onChange={e =>
                  handleChange('destination', 'personName', e.target.value)
                }
                error={Boolean(errors.destination?.personName)}
                helperText={errors.destination?.personName}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                size='small'
                fullWidth
                label='Phone'
                inputProps={{ maxLength: 14 }}
                value={formatPhoneNumber(formData.destination?.phoneNumber)}
                onChange={e =>
                  handleChange(
                    'destination',
                    'phoneNumber',
                    formatPhoneNumber(e.target.value)
                  )
                }
                error={Boolean(errors.destination?.phoneNumber)}
                helperText={errors.destination?.phoneNumber}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                size='small'
                fullWidth
                label='Email'
                value={formData.destination?.email}
                onChange={e =>
                  handleChange('destination', 'email', e.target.value)
                }
                error={Boolean(errors.destination?.email)}
                helperText={errors.destination?.email}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end'
                }}
              >
                <Grid>
                  <Typography fontWeight={500}>Delivery Hours</Typography>
                </Grid>
                <Grid
                  container
                  gap={1}
                  sx={{
                    mt: 1,
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <Grid sm={5.8}>
                    <TextField
                      size='small'
                      label='Open Time'
                      InputLabelProps={{ shrink: true }}
                      value={formData?.destinationOpenTime || ''}
                      onChange={e => {
                        handleChange('', 'destinationOpenTime', e.target.value);
                      }}
                      type='time'
                      fullWidth
                    />
                  </Grid>
                  <Grid sm={5.8}>
                    <TextField
                      size='small'
                      label='Close Time'
                      InputLabelProps={{ shrink: true }}
                      value={formData?.destinationCloseTime || ''}
                      onChange={e => {
                        handleChange(
                          '',
                          'destinationCloseTime',
                          e.target.value
                        );
                      }}
                      type='time'
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} mt={2}>
              <Typography fontWeight={500}>Line Item</Typography>
            </Grid>
            <Grid item xs={12}>
              {viewShipmentsDetails.map((details, index) => (
                <TextField
                  key={index}
                  sx={{ mb: 2 }}
                  size='small'
                  fullWidth
                  label={`Item Description ${index + 1}`}
                  value={details.itemDescription}
                  onChange={e => {
                    const updatedDetails = viewShipmentsDetails.map(
                      (item, i) =>
                        i === index
                          ? { ...item, itemDescription: e.target.value }
                          : item
                    );

                    setViewShipmentsDetails(updatedDetails);
                  }}
                />
              ))}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setFormData({});
              props?.handleCloseBolDialog(false);
            }}
          >
            Cancel
          </Button>
          {bolLoader ? (
            <Box
              sx={{ minWidth: 90, display: 'flex', justifyContent: 'center' }}
            >
              <CircularTMSLoader size={60} variant='progress' />
            </Box>
          ) : (
            <Button onClick={handleSave} variant='contained' color='primary'>
              Confirm
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* LABELS DIALOG */}
      <Dialog
        fullWidth
        maxWidth='md'
        minWidth='xs'
        sx={
          isMobile
            ? {
                '& .MuiDialog-paper': {
                  overflow: 'hidden',
                  minWidth: '3.6in',
                  maxWidth: '3.6in',
                  height: '90vh'
                }
              }
            : {
                '& .MuiDialog-paper': {
                  overflow: 'hidden',
                  minWidth: '4.2in',
                  maxWidth: '4.2in',
                  height: '90vh'
                }
              }
        }
        open={openLabelsDialog}
        onClose={hanldeCloseLabels}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>{openPrintPDfDialogData.carrierName} labels</div>
            <div>
              <CloseIcon
                sx={{ cursor: 'pointer' }}
                onClick={hanldeCloseLabels}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{ display: 'flex', justifyContent: 'center' }}
            id='alert-dialog-description'
          >
            <PackagingSlip
              contentRef={contentRef}
              rowData={rowData}
              isMobile={isMobile}
              numberOfPrints={numberOfPrints}
              openPrintPDfDialogData={openPrintPDfDialogData}
              numberOfPrintsColmnVise={numberOfPrintsColmnVise}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <div>
            <label style={{ fontSize: '13' }} htmlFor='printSelect'>
              Number of Prints:
            </label>
            <select
              className='mx-1'
              id='printSelect'
              value={selectedPrintOption}
              onChange={e => {
                handleChangeNoOfPrints(e);
              }}
            >
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={4}>4</option>
              <option value={6}>6</option>
            </select>
          </div>
          <Button
            size='small'
            variant='contained'
            onClick={() =>
              generatePDF(openPrintPDfDialogData.carrierName, 50, 750, 'labels')
            }
          >
            Generate PDF
          </Button>
          <Button
            size='small'
            variant='contained'
            onClick={() => handlePrint()}
          >
            Print
          </Button>
        </DialogActions>
      </Dialog>

      {/* BOL DIALOG */}
      <Dialog
        fullScreen={isMobile}
        fullWidth
        maxWidth='lg'
        open={openPrintPDfDialog}
        onClose={handlePDFPrintClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          <div style={{ display: 'flex', justifyContent: 'end' }}>
            <div>
              <CloseIcon
                sx={{ cursor: 'pointer' }}
                onClick={handlePDFPrintClose}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText ref={contentRef} id='alert-dialog-description'>
            <div
              id='pdf-content'
              style={{
                minWidth: '100%',
                minHeight: '100%'
              }}
            >
              <BillOfLading rowData={viewShipmentsDetails} rowData2={rowData} />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            size='small'
            variant='contained'
            onClick={() => generatePDF(rowData.carrierName, 850, 1250, 'bol')}
          >
            Generate PDF
          </Button>
          <Button
            onClick={() => handleUpdateBOLDialog(rowData)}
            color='warning'
            size='small'
            variant='contained'
          >
            Update BOL
          </Button>
        </DialogActions>
      </Dialog>

      {/* SHIPMENT INFO GRID - 4 equal-width cards */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {/* CARD 3: ORIGIN / DESTINATION / BILL TO merged - icons only, no field labels */}
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            elevation={0}
            sx={{
              border: '1px solid #e2e8f0',
              borderRadius: '10px',
              p: 2,
              height: '100%'
            }}
          >
            {/* Origin */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1,
                pb: 0.8,
                borderBottom: '1px solid #f1f5f9'
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  bgcolor: '#16a34a',
                  flexShrink: 0
                }}
              />
              <Typography
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: '#16a34a',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5
                }}
              >
                Origin
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.6,
                mb: 1.5
              }}
            >
              {rowData?.originCompany && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <BusinessIcon
                    sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                  />
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.originCompany}
                  </Typography>
                </Box>
              )}
              {(rowData?.originAddress || rowData?.originCity) && (
                <Box
                  sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.8 }}
                >
                  <LocationOnIcon
                    sx={{
                      fontSize: 14,
                      color: '#94a3b8',
                      flexShrink: 0,
                      mt: 0.2
                    }}
                  />
                  <Typography sx={{ fontSize: 13, color: '#374151' }}>
                    {[
                      rowData?.originAddress,
                      [
                        rowData?.originCity,
                        rowData?.originState,
                        rowData?.originZipCode
                      ]
                        .filter(Boolean)
                        .join(', ')
                    ]
                      .filter(Boolean)
                      .join(', ')}
                  </Typography>
                </Box>
              )}
              {(originDetails?.personName || rowData?.originContactPerson) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <PersonOutlineIcon
                    sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                  />
                  <Typography sx={{ fontSize: 13, color: '#374151' }}>
                    {originDetails?.personName || rowData.originContactPerson}
                  </Typography>
                </Box>
              )}
              {(originDetails?.contactPhone || rowData?.originContactPhone) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <LocalPhoneIcon
                    sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                  />
                  <Typography sx={{ fontSize: 13, color: '#374151' }}>
                    {formatPhoneNumber(
                      originDetails?.contactPhone || rowData.originContactPhone
                    )}
                  </Typography>
                </Box>
              )}
              {(originDetails?.contactEmail || rowData?.originContactEmail) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <EmailIcon
                    sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                  />
                  <Typography
                    sx={{
                      fontSize: 13,
                      color: '#374151',
                      wordBreak: 'break-all'
                    }}
                  >
                    {originDetails?.contactEmail || rowData.originContactEmail}
                  </Typography>
                </Box>
              )}
              {pickupDateValue && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <CalendarTodayIcon
                    sx={{ fontSize: 13, color: '#16a34a', flexShrink: 0 }}
                  />
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#16a34a' }}
                  >
                    {pickupDateValue}
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Destination */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1,
                pb: 0.8,
                borderBottom: '1px solid #f1f5f9'
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  bgcolor: '#dc2626',
                  flexShrink: 0
                }}
              />
              <Typography
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: '#dc2626',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5
                }}
              >
                Destination
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.6,
                mb: 1.5
              }}
            >
              {rowData?.destinationCompany && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <BusinessIcon
                    sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                  />
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.destinationCompany}
                  </Typography>
                </Box>
              )}
              {(rowData?.destinationAddress || rowData?.destinationCity) && (
                <Box
                  sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.8 }}
                >
                  <LocationOnIcon
                    sx={{
                      fontSize: 14,
                      color: '#94a3b8',
                      flexShrink: 0,
                      mt: 0.2
                    }}
                  />
                  <Typography sx={{ fontSize: 13, color: '#374151' }}>
                    {[
                      rowData?.destinationAddress,
                      [
                        rowData?.destinationCity,
                        rowData?.destinationState,
                        rowData?.destinationZipCode
                      ]
                        .filter(Boolean)
                        .join(', ')
                    ]
                      .filter(Boolean)
                      .join(', ')}
                  </Typography>
                </Box>
              )}
              {(destinationDetails?.personName ||
                rowData?.destinationContactPerson) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <PersonOutlineIcon
                    sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                  />
                  <Typography sx={{ fontSize: 13, color: '#374151' }}>
                    {destinationDetails?.personName ||
                      rowData.destinationContactPerson}
                  </Typography>
                </Box>
              )}
              {(destinationDetails?.contactPhone ||
                rowData?.destinationContactPhone) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <LocalPhoneIcon
                    sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                  />
                  <Typography sx={{ fontSize: 13, color: '#374151' }}>
                    {formatPhoneNumber(
                      destinationDetails?.contactPhone ||
                        rowData.destinationContactPhone
                    )}
                  </Typography>
                </Box>
              )}
              {(destinationDetails?.contactEmail ||
                rowData?.destinationContactEmail) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <EmailIcon
                    sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                  />
                  <Typography
                    sx={{
                      fontSize: 13,
                      color: '#374151',
                      wordBreak: 'break-all'
                    }}
                  >
                    {destinationDetails?.contactEmail ||
                      rowData.destinationContactEmail}
                  </Typography>
                </Box>
              )}
              {deliveryDateValue && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <CalendarTodayIcon
                    sx={{ fontSize: 13, color: '#dc2626', flexShrink: 0 }}
                  />
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#dc2626' }}
                  >
                    {deliveryDateValue}
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Bill To */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1,
                pb: 0.8,
                borderBottom: '1px solid #f1f5f9'
              }}
            >
              <AccountBalanceIcon
                sx={{ fontSize: 13, color: '#b91c1c', flexShrink: 0 }}
              />
              <Typography
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: '#1e293b',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5
                }}
              >
                Bill To
              </Typography>
            </Box>
            {rowData?.billToCompany ||
            rowData?.billToAddress ||
            rowData?.billToContactPhone ||
            rowData?.billToContactEmail ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                {rowData?.billToCompany && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <BusinessIcon
                      sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                    />
                    <Typography
                      sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                    >
                      {rowData.billToCompany}
                    </Typography>
                  </Box>
                )}
                {(rowData?.billToAddress || rowData?.billToCity) && (
                  <Box
                    sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.8 }}
                  >
                    <LocationOnIcon
                      sx={{
                        fontSize: 14,
                        color: '#94a3b8',
                        flexShrink: 0,
                        mt: 0.2
                      }}
                    />
                    <Typography sx={{ fontSize: 13, color: '#374151' }}>
                      {[
                        [rowData?.billToAddress, rowData?.billToAddress2]
                          .filter(Boolean)
                          .join(', '),
                        [
                          rowData?.billToZipCode,
                          rowData?.billToCity,
                          rowData?.billToState
                        ]
                          .filter(Boolean)
                          .join(', ')
                      ]
                        .filter(Boolean)
                        .join(', ')}
                    </Typography>
                  </Box>
                )}
                {rowData?.billToContactPhone && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <LocalPhoneIcon
                      sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                    />
                    <Typography sx={{ fontSize: 13, color: '#374151' }}>
                      {formatPhoneNumber(rowData.billToContactPhone)}
                    </Typography>
                  </Box>
                )}
                {rowData?.billToContactEmail && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <EmailIcon
                      sx={{ fontSize: 14, color: '#94a3b8', flexShrink: 0 }}
                    />
                    <Typography
                      sx={{
                        fontSize: 11,
                        color: '#374151',
                        wordBreak: 'break-all'
                      }}
                    >
                      {rowData.billToContactEmail}
                    </Typography>
                  </Box>
                )}
              </Box>
            ) : (
              <Typography
                sx={{ fontSize: 13, color: '#94a3b8', fontStyle: 'italic' }}
              >
                No billing info available
              </Typography>
            )}
          </Paper>
        </Grid>

        {/* CARD 2: SHIPMENT INFO */}
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            elevation={0}
            sx={{
              border: '1px solid #e2e8f0',
              borderRadius: '10px',
              p: 2,
              height: '100%'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1.5,
                pb: 1,
                borderBottom: '1px solid #f1f5f9'
              }}
            >
              <Box
                sx={{
                  bgcolor: '#f5f3ff',
                  borderRadius: '6px',
                  p: 0.4,
                  display: 'flex'
                }}
              >
                <Inventory2OutlinedIcon
                  sx={{ fontSize: 14, color: '#7c3aed' }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#1e293b',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5
                }}
              >
                Shipment Info
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
              {rowData?.shipmentType && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Shipment Type
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.shipmentType}
                  </Typography>
                </Box>
              )}
              {rowData?.locationName && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Ship Location
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.locationName}
                  </Typography>
                </Box>
              )}
              {rowData?.freightTerms && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Payment Type
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {{
                      OutboundPrepaid: 'Outbound Prepaid',
                      InboundCollect: 'Inbound Collect',
                      ThirdParty: '3rd Party'
                    }[rowData.freightTerms] || rowData.freightTerms}
                  </Typography>
                </Box>
              )}
              {totalW > 0 && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Total Weight
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {Number(totalW).toLocaleString()} lbs
                  </Typography>
                </Box>
              )}
              {totalUnits > 0 && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Total Pallets
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {totalUnits}
                  </Typography>
                </Box>
              )}
              {totalPcs > 0 && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Pieces
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {totalPcs}
                  </Typography>
                </Box>
              )}
              {rowData?.isHazmat && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Hazmat
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 700, color: '#dc2626' }}
                  >
                    Yes
                  </Typography>
                </Box>
              )}
              {rowData?.soNumber && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Shipment #
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.soNumber}
                  </Typography>
                </Box>
              )}
              {rowData?.serviceType && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Service
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.serviceType}
                  </Typography>
                </Box>
              )}
              {rowData?.shipmentType === 'TL' &&
                rowData?.motorCarrierNumber && (
                  <Box>
                    <Typography
                      sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                    >
                      MC #
                    </Typography>
                    <Typography
                      sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                    >
                      {rowData.motorCarrierNumber}
                    </Typography>
                  </Box>
                )}
              {rowData?.shipmentType === 'TL' && rowData?.trailerNumber && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Truck/Trailer #
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.trailerNumber}
                  </Typography>
                </Box>
              )}
              {rowData?.shipmentMiles && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Distance
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.shipmentMiles} miles
                  </Typography>
                </Box>
              )}
            </Box>
          </Paper>
        </Grid>

        {/* CARD 1: CARRIER & REFERENCES (replaces old header bar) */}
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            elevation={0}
            sx={{
              border: '1px solid #e2e8f0',
              borderRadius: '10px',
              p: 2,
              height: '100%'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1.5,
                pb: 1,
                borderBottom: '1px solid #f1f5f9'
              }}
            >
              <Box
                sx={{
                  bgcolor: '#eff6ff',
                  borderRadius: '6px',
                  p: 0.4,
                  display: 'flex'
                }}
              >
                <LocalShippingIcon sx={{ fontSize: 14, color: '#2563eb' }} />
              </Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#1e293b',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5
                }}
              >
                Carrier & Documents
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 1
                }}
              >
                <Box
                  sx={{
                    width: 88,
                    height: 56,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '6px',
                    border: '1px solid #e2e8f0',
                    bgcolor: '#f8fafc',
                    overflow: 'hidden'
                  }}
                >
                  {rowData?.carrierLogo ? (
                    <img
                      src={base_logo_url + rowData.carrierLogo}
                      alt={rowData?.carrierName || ''}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  ) : (
                    <LocalShippingIcon
                      sx={{ fontSize: 22, color: '#94a3b8' }}
                    />
                  )}
                </Box>
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    px: 1.2,
                    py: 0.4,
                    borderRadius: '20px',
                    fontSize: 11,
                    fontWeight: 700,
                    flexShrink: 0,
                    ...getShipmentStatusColor(shipmentStatus)
                  }}
                >
                  {shipmentStatus || 'Pending'}
                </Box>
              </Box>
              <Typography
                sx={{ fontSize: 14, fontWeight: 700, color: '#1e293b' }}
              >
                {rowData?.carrierName || '—'}
              </Typography>
              {referenceNumber !== '—' && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Reference #
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Typography
                      sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                    >
                      {referenceNumber}
                    </Typography>
                    <ContentCopyIcon
                      sx={{ fontSize: 12, color: '#94a3b8', cursor: 'pointer' }}
                      onClick={() =>
                        navigator.clipboard.writeText(referenceNumber)
                      }
                    />
                  </Box>
                </Box>
              )}
              {rowData?.pickupNumber && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Pickup #
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.pickupNumber}
                  </Typography>
                </Box>
              )}
              {rowData?.bolNumber && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    BOL #
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.bolNumber}
                  </Typography>
                </Box>
              )}
              {rowData?.quoteNumber && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Quote #
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.quoteNumber}
                  </Typography>
                </Box>
              )}
              {rowData?.clientPONumber && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    PO #
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.clientPONumber}
                  </Typography>
                </Box>
              )}
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Pickup Date
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#16a34a' }}
                  >
                    {pickupDateValue || '—'}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Exp. Delivery
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#dc2626' }}
                  >
                    {deliveryDateValue || '—'}
                  </Typography>
                </Box>
              </Box>
              {rowData?.estimatedTransitDays && (
                <Box>
                  <Typography
                    sx={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}
                  >
                    Transit Days
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                  >
                    {rowData.estimatedTransitDays}
                  </Typography>
                </Box>
              )}
              <ShipmentDocuments
                shipmentStatus={shipmentStatus}
                shipmentType={props?.rowData?.shipmentType}
                claimDetails={claimDetails}
                onPrintBOL={() => setOpenPrintPDfDialog(true)}
                onPrintLabels={() => printData(rowData)}
                onDownloadPOD={() => handleProofOfDeliveryRequest('')}
                podLoading={PodDocLoader}
              />
            </Box>
          </Paper>
        </Grid>

        {/* CARD 4: SHIP ANALYSIS - booked vs least-cost carrier */}
        <Grid item xs={12} sm={6} md={3}>
          <Paper
            elevation={0}
            sx={{
              border: '1px solid #e2e8f0',
              borderRadius: '10px',
              p: 2,
              height: '100%'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1.5,
                pb: 1,
                borderBottom: '1px solid #f1f5f9'
              }}
            >
              <Box
                sx={{
                  bgcolor: '#ecfdf5',
                  borderRadius: '6px',
                  p: 0.4,
                  display: 'flex'
                }}
              >
                <AnalyticsIcon sx={{ fontSize: 14, color: '#059669' }} />
              </Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#1e293b',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5
                }}
              >
                Ship Analysis
              </Typography>
            </Box>
            {rowData?.leastCostCarrier && rowData?.leastCost != null ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: '8px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 11,
                      color: '#94a3b8',
                      fontWeight: 600,
                      textTransform: 'uppercase'
                    }}
                  >
                    Booked Carrier
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.8,
                      mt: 0.3
                    }}
                  >
                    <Box
                      sx={{
                        width: 48,
                        height: 32,
                        flexShrink: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '4px',
                        border: '1px solid #e2e8f0',
                        bgcolor: '#fff',
                        overflow: 'hidden'
                      }}
                    >
                      {rowData?.carrierLogo ? (
                        <img
                          src={base_logo_url + rowData.carrierLogo}
                          alt={rowData?.carrierName || ''}
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain'
                          }}
                        />
                      ) : (
                        <LocalShippingIcon
                          sx={{ fontSize: 18, color: '#94a3b8' }}
                        />
                      )}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: '#1e293b',
                        wordBreak: 'break-word'
                      }}
                    >
                      {rowData?.carrierName || '—'}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      mt: 0.5
                    }}
                  >
                    <Typography
                      sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}
                    >
                      {rowData?.shipmentCharges != null
                        ? `$${Number(rowData.shipmentCharges).toFixed(2)}`
                        : '—'}
                    </Typography>
                    {rowData?.estimatedTransitDays && (
                      <Typography sx={{ fontSize: 12, color: '#64748b' }}>
                        {rowData.estimatedTransitDays} days
                      </Typography>
                    )}
                  </Box>
                </Box>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: '8px',
                    bgcolor: '#f0fdf4',
                    border: '1px solid #bbf7d0'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 11,
                      color: '#16a34a',
                      fontWeight: 600,
                      textTransform: 'uppercase'
                    }}
                  >
                    Least Cost Carrier
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.8,
                      mt: 0.3
                    }}
                  >
                    <Box
                      sx={{
                        width: 48,
                        height: 32,
                        flexShrink: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '4px',
                        border: '1px solid #bbf7d0',
                        bgcolor: '#fff',
                        overflow: 'hidden'
                      }}
                    >
                      {leastCostCarrierInfo?.logo ? (
                        <img
                          src={base_logo_url + leastCostCarrierInfo.logo}
                          alt={leastCostCarrierInfo?.name || ''}
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain'
                          }}
                        />
                      ) : (
                        <LocalShippingIcon
                          sx={{ fontSize: 18, color: '#16a34a' }}
                        />
                      )}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: '#1e293b',
                        wordBreak: 'break-word'
                      }}
                    >
                      {leastCostCarrierInfo?.name ||
                        rowData.leastCostCarrier ||
                        '—'}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 600,
                      color: '#1e293b',
                      mt: 0.5
                    }}
                  >
                    $
                    {(
                      Number(rowData.leastCost) +
                      Number(rowData?.leastCostAgencySurcharge || 0)
                    ).toFixed(2)}
                  </Typography>
                </Box>
                {rowData?.shipmentCharges != null &&
                  (() => {
                    const leastTotal =
                      Number(rowData.leastCost) +
                      Number(rowData?.leastCostAgencySurcharge || 0);
                    const diff = Number(rowData.shipmentCharges) - leastTotal;
                    return diff > 0 ? (
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                      >
                        <TrendingDownIcon
                          sx={{ fontSize: 14, color: '#16a34a' }}
                        />
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: '#16a34a'
                          }}
                        >
                          Could have saved ${diff.toFixed(2)}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography sx={{ fontSize: 12, color: '#64748b' }}>
                        Booked at the lowest available rate
                      </Typography>
                    );
                  })()}
              </Box>
            ) : (
              <Typography
                sx={{ fontSize: 13, color: '#94a3b8', fontStyle: 'italic' }}
              >
                No rate comparison available for this shipment
              </Typography>
            )}
          </Paper>
        </Grid>
      </Grid>

      {/* COMMODITY INFORMATION */}
      {commodityRows.length > 0 && (
        <Paper
          elevation={0}
          sx={{
            border: '1px solid #e2e8f0',
            borderRadius: '10px',
            p: 2,
            mb: 2
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
            <Box
              sx={{
                bgcolor: '#fff7ed',
                borderRadius: '8px',
                p: 0.6,
                display: 'flex'
              }}
            >
              <Inventory2OutlinedIcon sx={{ fontSize: 16, color: '#ea580c' }} />
            </Box>
            <Typography
              sx={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}
            >
              Commodity Information
            </Typography>
          </Box>
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table size='small' sx={{ minWidth: 600 }}>
              <TableHead>
                <TableRow sx={{ bgcolor: '#f8fafc' }}>
                  {[
                    'Weight (lbs)',
                    'Freight Class',
                    'Unit Type',
                    'Units',
                    'Pieces',
                    'NMFC',
                    'L (in)',
                    'W (in)',
                    'H (in)'
                  ].map(h => (
                    <TableCell
                      key={h}
                      sx={{
                        fontSize: 10,
                        fontWeight: 700,
                        color: '#64748b',
                        textTransform: 'uppercase',
                        letterSpacing: 0.3,
                        py: '6px',
                        px: '8px',
                        borderBottom: '1px solid #e2e8f0',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {commodityRows.map((c, i) => (
                  <TableRow
                    key={i}
                    sx={{ '&:last-child td': { borderBottom: 0 } }}
                  >
                    <TableCell
                      sx={{
                        fontSize: 11,
                        color: '#1e293b',
                        py: '6px',
                        px: '8px'
                      }}
                    >
                      {c.netWeight > 0
                        ? Number(c.netWeight).toLocaleString()
                        : '—'}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: 11,
                        color: '#1e293b',
                        py: '6px',
                        px: '8px'
                      }}
                    >
                      {c.freightClass || '—'}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: 11,
                        color: '#1e293b',
                        py: '6px',
                        px: '8px'
                      }}
                    >
                      {c.packagingType || '—'}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: 11,
                        color: '#1e293b',
                        py: '6px',
                        px: '8px'
                      }}
                    >
                      {c.units || '—'}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: 11,
                        color: '#1e293b',
                        py: '6px',
                        px: '8px'
                      }}
                    >
                      {c.pieces || '—'}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: 11,
                        color: '#1e293b',
                        py: '6px',
                        px: '8px'
                      }}
                    >
                      {c.nmfc || '—'}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: 11,
                        color: '#1e293b',
                        py: '6px',
                        px: '8px'
                      }}
                    >
                      {c.length || '—'}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: 11,
                        color: '#1e293b',
                        py: '6px',
                        px: '8px'
                      }}
                    >
                      {c.width || '—'}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: 11,
                        color: '#1e293b',
                        py: '6px',
                        px: '8px'
                      }}
                    >
                      {c.height || '—'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}

      {/* TIMELINE & TRACKING - COMPACT SINGLE LINE */}
      {shipmentStatus !== 'Booked' && (
        <Paper
          elevation={0}
          sx={{
            border: '1px solid #e2e8f0',
            borderRadius: '10px',
            p: 2,
            mb: 2
          }}
        >
          {/* Single-line header: icon + title | PRO# | VIEW HISTORY */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 1.5
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box
                sx={{
                  bgcolor: '#eff6ff',
                  borderRadius: '8px',
                  p: 0.6,
                  display: 'flex'
                }}
              >
                <TimelineIcon sx={{ fontSize: 16, color: '#2563eb' }} />
              </Box>
              <Typography
                sx={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}
              >
                Timeline & Tracking
              </Typography>
              {rowData?.proNumber && (
                <>
                  <Box sx={{ width: '1px', height: 16, bgcolor: '#e2e8f0' }} />
                  <Typography
                    sx={{ fontSize: 11, color: '#94a3b8', fontWeight: 600 }}
                  >
                    PRO #
                  </Typography>
                  <Typography
                    sx={{ fontSize: 15, fontWeight: 700, color: '#1976d2' }}
                  >
                    {rowData.proNumber}
                  </Typography>
                </>
              )}
            </Box>
            {trackShipmentData?.tracingLines?.length > 0 && (
              <TrackHistory trackShipmentData={trackShipmentData} />
            )}
          </Box>

          <Box>
            {rowData?.shipmentType === 'TL' ? (
              (shipmentStatus === 'InTransit' ||
                shipmentStatus === 'Delivered') && (
                <div>
                  <div className='d-flex flex-column justify-content-center h-100'>
                    {!docLoader ? (
                      historyError ? (
                        <Box
                          sx={{ textAlign: 'center' }}
                          className='Chat_Child_View_Shipment'
                        >
                          <br />
                          <br />
                          <br />
                          <br />
                          <WarningAmberIcon
                            style={{ fontSize: 150, color: '#D32F2F' }}
                          />{' '}
                          {/* <br /> */}
                          <br />
                          <Typography variant='h5'>
                            No history found for this shipment!
                          </Typography>
                          <br />
                          <br />
                          <br />
                        </Box>
                      ) : (
                        <div className='Chat_Child_View_Shipment py-2 pt-4 h-100'>
                          {shipperApiMsgs &&
                            shipperApiMsgs.map(carrierRes => (
                              <div
                                style={
                                  carrierRes.actionByFlag.toLowerCase() ===
                                  'carrier'
                                    ? {
                                        display: 'flex',
                                        justifyContent: 'start',
                                        flexDirection: 'column',
                                        marginLeft: 10,
                                        marginRight: 10,
                                        width: 400,
                                        position: 'relative'
                                      }
                                    : {
                                        display: 'flex',
                                        justifyContent: 'end',
                                        // flexDirection: 'column',
                                        marginLeft: 10,
                                        marginRight: 10,
                                        position: 'relative'
                                      }
                                }
                              >
                                {carrierRes.actionByFlag.toLowerCase() ===
                                  'carrier' && (
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'start'
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: '#e0f2f1',
                                        borderRadius: '50%',
                                        width: '45',
                                        height: '45',
                                        textAlign: 'center',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        marginRight: 10
                                      }}
                                    >
                                      <img
                                        style={{
                                          borderRadius: '50%',
                                          width: '45',
                                          height: '45',
                                          textAlign: 'center',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          objectFit: 'cover'
                                        }}
                                        alt=''
                                        src={
                                          base_logo_url +
                                          carrierApiMsgs[0]?.actionByImage
                                        }
                                      />
                                    </div>
                                    <div>
                                      <b style={{ fontSize: 18 }}>
                                        {carrierApiMsgs &&
                                          carrierApiMsgs[0]?.actionByName}
                                      </b>
                                      <br />
                                      <span style={{ fontWeight: 600 }}>
                                        {carrierApiMsgs[0]?.actionByDesignation}
                                      </span>
                                    </div>
                                  </div>
                                )}
                                <div>
                                  {carrierRes.actionByFlag.toLowerCase() ===
                                    'shipper' && (
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'end'
                                      }}
                                    >
                                      <div
                                        style={{
                                          marginLeft: 0,
                                          marginRight: 1,
                                          textAlign: 'right'
                                        }}
                                      >
                                        <b style={{ fontSize: 18 }}>
                                          {shipperApiMsgs &&
                                            shipperApiMsgs[0]?.actionByName}
                                        </b>
                                        <br />
                                        <span style={{ fontWeight: 600 }}>
                                          {
                                            shipperApiMsgs[0]
                                              ?.actionByDesignation
                                          }
                                        </span>
                                        <br />
                                      </div>
                                      <div
                                        style={{
                                          backgroundColor: '#e0f2f1',
                                          borderRadius: '50%',
                                          width: '45',
                                          height: '45',
                                          textAlign: 'center',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          marginLeft: 10
                                        }}
                                      >
                                        <img
                                          style={{
                                            borderRadius: '50%',
                                            width: '45',
                                            height: '45',
                                            textAlign: 'center',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            objectFit: 'cover'
                                          }}
                                          alt=''
                                          src={
                                            base_logo_url +
                                            shipperApiMsgs[0]?.actionByImage
                                          }
                                        />
                                      </div>
                                    </div>
                                  )}
                                  <div
                                    style={
                                      carrierRes.actionByFlag.toLowerCase() ===
                                      'shipper'
                                        ? {
                                            marginBottom: '10vh',
                                            backgroundColor: '#e0f2f1',
                                            borderRadius: '10px 0px 10px 10px',
                                            padding: '10px',
                                            transform: '(rotateX(180deg)'
                                          }
                                        : {
                                            marginBottom: '10vh',
                                            backgroundColor: '#eceff1',
                                            padding: '10px',
                                            borderRadius: '0px 10px 10px 10px'
                                          }
                                    }
                                  >
                                    <div
                                      style={{ fontSize: 12 }}
                                      dangerouslySetInnerHTML={{
                                        __html: handleCorresHistory(
                                          carrierRes.actionData
                                        )
                                      }}
                                    ></div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        fontSize: 11
                                      }}
                                    >
                                      {handleDateTimeShow(
                                        carrierRes.date,
                                        'time'
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                          {/* <div ref={bottomRef} /> */}
                        </div>
                      )
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '50vw',
                          height: '90%'
                        }}
                      >
                        <CircularTMSLoader size={60} variant='progress' />
                      </div>
                    )}
                  </div>
                </div>
              )
            ) : (
              <Box sx={{ width: '100%' }}>
                {trackShipmentData && (
                  <TrackShipmentDetails
                    trackShipmentData={trackShipmentData}
                    view={viewType}
                    rowData={rowData}
                  />
                )}
              </Box>
            )}
          </Box>
        </Paper>
      )}
    </Box>
  );
}

export default ViewShipment;
